import React from 'react';
import WidgetTitle from './widgetTitle';
import { Wrapper, SubTitle, ColumnWrapper } from './css';
const SectionWrapper = (widgetData) => {
    const { params, children } = widgetData;
    const { title, subTitle, titleAlign, imageUrl, backGroundColor, } = params;
    return (React.createElement(Wrapper, { align: titleAlign, color: backGroundColor },
        imageUrl && (React.createElement("img", { src: imageUrl, alt: title })),
        title && (React.createElement(WidgetTitle, { title: title })),
        subTitle && (React.createElement(SubTitle, null, subTitle)),
        React.createElement("div", { className: "list-wrap" }, children && children.map((column) => (React.createElement(ColumnWrapper, null, column))))));
};
export default SectionWrapper;
